import { FeatherModule } from 'angular-feather';
import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnDestroy,
  output,
  TemplateRef,
} from '@angular/core';

import { TooltipComponent } from '../tooltip/tooltip.component';

@Component({
  selector: 'lib-icon-button',
  imports: [TooltipComponent, FeatherModule, NgTemplateOutlet],
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconButtonComponent implements OnDestroy {
  readonly icon = input('');
  readonly customIcon = input<TemplateRef<unknown> | null>(null);
  readonly tooltip = input<string>();
  readonly ariaLabel = input<string>();
  readonly tooltipPosition = input<'top' | 'bottom' | 'left' | 'right'>('top');
  readonly size = input<number | undefined>(36);
  readonly noBackground = input(false);
  readonly backgroundColor = input<string | undefined>();
  readonly active = input(false);
  readonly disabled = input(false);
  readonly tabIndex = input<number | null | undefined>(undefined);

  readonly clicked = output<void>();

  isTooltipVisible = false;

  handleClick() {
    // TODO: The 'emit' function requires a mandatory void argument
    this.hideTooltip(); //removes last opened tooltip on click
    this.clicked.emit();
  }

  showTooltip() {
    if (!this.disabled) {
      this.isTooltipVisible = true;
    }
  }

  hideTooltip() {
    this.isTooltipVisible = false;
  }

  ngOnDestroy() {
    this.hideTooltip(); // Ensure tooltip is hidden when component is destroyed
  }
}
